// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__5G0xb","section":"styles_section__JNyTc"};